module.exports = __webpack_public_path__ + "static/media/mastercard.d7f2f29f.svg";